module.exports = __webpack_public_path__ + "static/media/marketing-grow-calendar.b83aca06.png";